import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    // {
    //     cameraLocationId: 'LBB',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'Lobby',
    //     cameraPosition: new Vector3(6.459, -1, .408),
    //     cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
    //     displayMesh: 'Y', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    //     // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
    //     // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
    //     cameraLocationLevel2Id: ['BSCH01']
    // },
    // {
    //     cameraLocationId: 'BSCH01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'BSH',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    //     // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
    //     // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
    //     cameraLocationIdOfChild: 'Y',
    // },


    {
        cameraLocationId: 'Arc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Architecture',
        // cameraPosition: new Vector3(6.459, -1, .408),
        // cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
        // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationLevel2Id: ['BSCH01']
    },
    {
        cameraLocationId: 'Cre',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Creative',
        // cameraPosition: new Vector3(6.459, -1, .408),
        // cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
        // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationLevel2Id: ['BSCH01']
    },
    {
        cameraLocationId: 'Dis',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Discovery',
    },
    {
        cameraLocationId: 'Doc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Documentary',
    },
    {
        cameraLocationId: 'Env',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Environment',
    },
    {
        cameraLocationId: 'Lnd',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Landscape',
    },
    {
        cameraLocationId: 'NWW',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Natural World & Wildlife',
    },
    {
        cameraLocationId: 'Por',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Portraiture',
    },
    {
        cameraLocationId: 'Spo',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sport',
    },
    {
        cameraLocationId: 'SL',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Still Life',
    },
    {
        cameraLocationId: 'GeneralSWPAWelcome',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Overall Introduction',
    },
    {
        cameraLocationId: 'Competitions',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Pro & Open Competition Introduction ',
    },
    {
        cameraLocationId: 'ProLatamAward',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: '2020 Latin America Competition',
    },
    {
        cameraLocationId: 'StudentSonyGrant',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: '2020 Sony Grant - Student',
    },
    {
        cameraLocationId: 'ProfessionalSonyGrant',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: '2020 Sony Grant - Professional',
    },
    {
        cameraLocationId: 'AlphaFemaleAward',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: '2020 Sony Alpha Female Award',
    },
    {
        cameraLocationId: 'FrenchSelection',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'French Selection',
        cameraLocationOffset: 1.5,
        displayMesh: 'N'
    },
    {
        cameraLocationId: 'ExitBoard',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Exit',
    },
    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    // }
];

export {CameraLocationsDB, FLOOR_NUMBER};
